export function getSMTiltPRProjectConfigurationData(projectEnvConfig: any) {
    const {
      zipcode,
      building_code,
      wind_speed,
      snow_load,
      seismic_ss,
      seismic_sds,
      elevation,
      wind_exposure,
      building_height,
      rail_finish,
      roof_type,    
      mean_recurrence_interval,
      preferred_span,
      tilt,
      rail_direction,
      rafter_spacing_inches,
      env_factors_for,
      client_address,
      client_name,
      created_user_time,
      building_type,
      shortest_building_length,
      risk_category,
      clamps_choices,
      tile_replacement_or_solarhooks,
      material_thickness ,
      attachment_type ,
      roof_substrate,
      mid_clamps_choices,
      end_clamps_choices,
      rail_type,
      parapet_height_input,
      building_length,
      soil_class,
      tornado_speed,
      domestic_content,
    } = projectEnvConfig;
  
    return {
      zipcode,
      building_code,
      wind_speed,
      snow_load,
      seismic_ss,
      seismic_sds,
      elevation,
      wind_exposure,
      building_height,
      rail_finish,
      roof_type,    
      mean_recurrence_interval,
      preferred_span,
      tilt,
      rail_direction,
      rafter_spacing_inches,
      env_factors_for,
      client_address,
      client_name,
      created_user_time,
      building_type,
      shortest_building_length,
      risk_category,
      clamps_choices,
      tile_replacement_or_solarhooks,
      material_thickness ,
      attachment_type ,
      roof_substrate,
      mid_clamps_choices,
      end_clamps_choices,
      rail_type,
      parapet_height_input,
      building_length,
      soil_class,
      tornado_speed,
      domestic_content,
    };
  }
  